import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { parseString } from 'xml2js';

import { PlessHttp } from './http/pless-http.service';
import { HttpHeaders } from '@angular/common/http';

/**
 * messages.xmlからデータを取得するサービス
 *
 * @export
 * @class GetMultiMessagesService
 */
@Injectable()
export class GetMultiMessagesService {

    constructor(protected plessHttp: PlessHttp) { }

    private filePath = 'app/messages.xml';
    private messageList: Array<any> = null;
    private messageIdArray;
    private replaceStrArray;
    private func;

    /**
     * 渡されたmessageIdとfuncを一時退避し、
     * messages.xmlから既にデータを取得しているか判定し、
     * 既に取得している場合は該当メッセージ取得の取得、
     * 未だ取得していない場合は、messages.xmlからのデータ取得処理を呼び出す
     *
     * @param {string} messageId メッセージID
     * @param {Function} func 後続処理
     * @memberof GetMessagesService
     */
    execute(messageId: Array<string>, replaceStr: Array<Array<string>>, func: Function) {
        this.messageIdArray = messageId;
        this.replaceStrArray = replaceStr;
        this.func = func;

        // 既にmessages.xmlから値を取得しているか判定
        if (this.messageList === null) {
            const response = this.plessHttp.get(this.filePath, 
                { headers: new HttpHeaders(), responseType: 'text', withCredentials: true });
            this.setMessageList(response);
        } else {
            this.getMessage();
        }
    }

    /**
     * messages.xmlからデータを取得し、
     * xml形式で解析後、変数へ格納する。
     *
     * @param {*} httpresponse messages.xml取得戻り値
     * @memberof GetMessagesService
     */
    setMessageList(httpresponse: any) {
        httpresponse.subscribe(
            response => {
                // xml解析
                parseString(response.body, (err, result) => {
                    if (err) {
                        // エラーの場合は、後続処理への引数をnullで設定
                        this.func(null);
                    } else {
                        // messages.xmlの戻りを設定し、
                        // 該当メッセージ取得処理を実行
                        this.messageList = result.Messages.Message;
                        this.getMessage();
                    }
                });
            },
            error => {
                // エラーの場合は、後続処理への引数をnullで設定
                this.func(null);
            }
        );
    }

    /**
     * 渡されてきたメッセージIDと一致するメッセージ情報を探し、
     * 該当するものがある場合は、戻り値へ設定後後続処理を呼び出す
     * 該当するものがない場合は、nullで後続処理を呼び出す
     *
     * @memberof GetMessagesService
     */
    getMessage() {
        let resultMessage = "";
        for (let i=0;i<this.messageIdArray.length;i++) {
            Object.keys(this.messageList).forEach((key) => {
                if (this.messageList[key].ID[0] === this.messageIdArray[i]) {

                    const replaceStr = this.replaceStrArray[i];
                    let tempStr = this.messageList[key].Description[0];
                    // 置換文字列が送られて来た場合は、
                    // 置換文字列を検索し、表示メッセージを編集する
                    if (replaceStr !== null && replaceStr !== undefined) {
                        Object.keys(replaceStr).forEach((key) => {
                            tempStr = tempStr.replace('{' + key + '}', replaceStr[key]);
                        });
                    }

                    resultMessage = resultMessage + "\n" + tempStr;
                }
            });
        }
        this.func(resultMessage.length === 0 ? resultMessage : resultMessage.slice(1));
    }
}
